import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { func, number, string } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import { Header } from './sidebar.styles';

const SidebarHeader = _ref => {
  let {
    children,
    variant,
    startIcon,
    fontSize,
    fontWeight,
    textAlign,
    ariaLabel,
    fill,
    onClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "variant", "startIcon", "fontSize", "fontWeight", "textAlign", "ariaLabel", "fill", "onClick"]);

  return /*#__PURE__*/React.createElement(Header, _extends({
    variant: variant,
    scale: "large",
    startIcon: startIcon && /*#__PURE__*/React.createElement(Icon, {
      name: startIcon,
      "aria-label": ariaLabel,
      fill: fill,
      onClick: onClick,
      "data-testid": "sidebar-header-icon"
    }),
    textAlign: textAlign,
    fontSize: fontSize,
    fontWeight: fontWeight,
    "data-testid": "sidebar-header"
  }, props), children);
};

process.env.NODE_ENV !== "production" ? SidebarHeader.propTypes = {
  children: string,
  startIcon: string,
  fontSize: number,
  fontWeight: string,
  textAlign: string,
  variant: string,
  ariaLabel: string,
  fill: string,
  onClick: func
} : void 0;
SidebarHeader.defaultProps = {
  children: null,
  variant: 'transparent',
  startIcon: 'ArrowBack',
  fontSize: 1,
  fontWeight: 'medium',
  textAlign: 'center',
  ariaLabel: 'fechar sidebar',
  fill: 'currentColor',
  onClick: () => {}
};
export default SidebarHeader;